/**
 * Japan Event Notice (Temporary)
 * @format
 */

import { safeCurrentLanguage } from './drupal-services';

/**
 * Setup Japan Event Notice.
 */
export const setupJapanEventNotice = (): void => {
  /**
   * Events Check.
   */
  const newsCheck = (): void => {
    const newsReleases: Element | null = document.querySelector(
      '.view-news-releases'
    );
    const frontPage: Element | null = document.querySelector(
      'body.path-frontpage'
    );
    if (newsReleases && frontPage && safeCurrentLanguage() === 'ja') {
      const notice: Element = document.createElement('div');
      notice.id = 'ja-announcement-notice';
      notice.innerHTML = `
        <a target="_blank" rel="noreffer noopener" href="https://varian.widen.net/s/6wvcq5fhgb">
          <h3>治療データバックアップの重要性について</h3>
        </a>`;
      newsReleases.parentElement?.prepend(notice);
    }
  };
  newsCheck();
};
